<template>
  <div class="tw-w-full">
    <div class="tw-w-full tw-pt-12 tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <h2 class="font-title tw-text-xl tw-mb-1">{{title}}</h2>
    </div>
    <div
      :class="[
        'tw-flex tw-flex-wrap',
        { '--loading-data': pageIsLoading }
      ]"
    >
      <div class="tw-w-full tw-mb-2 tw-flex-shrink-0 tw-px-1">
        <InputGroup
          label="Staff number"
          name="staff"
          type="text"
          placeholder="Staff number"
          input-classes="tw-p-3"
          input-type="text"
          v-model="form.staff"
          :error="errors.staff"
        />
      </div>
      <div class="tw-w-full tw-mb-2 tw-flex-shrink-0 tw-px-1">
        <SelectGroup
          label="Region"
          name="regional"
          nameKey="region"
          placeholder="Region"
          instruct="Search for your region"
          input-classes="my-select--huge tw-font-sans tw-bg-gray-200"
          v-model="form.regional"
          :options="regionalList"
          :reduce="region => region.id"
          :selected="form.regional"
          :clearable="false"
          filterable
          searchable
          :error="errors.regional"
        />
      </div>
      <div class="tw-w-full tw-mb-2 tw-flex-shrink-0 tw-px-1">
        <SelectGroup
          label="Section"
          name="section"
          nameKey="name"
          placeholder="Section"
          instruct="Search for your section"
          input-classes="my-select--huge tw-font-sans tw-bg-gray-200"
          v-model="form.section"
          :options="sectionList"
          :reduce="section => section.id"
          :selected="form.section"
          :clearable="false"
          filterable
          searchable
          :error="errors.section"
        />
      </div>
      <div class="tw-w-full tw-mb-2 tw-flex-shrink-0 tw-px-1">
        <!-- Grade is department level -->
        <SelectGroup
          label="Grade"
          name="level"
          nameKey="level"
          placeholder="Grade"
          instruct="Search for your grade"
          input-classes="my-select--huge tw-font-sans tw-bg-gray-200"
          v-model="form.dept_level"
          :options="deptLevelList"
          :reduce="deptLevel => deptLevel.id"
          :selected="form.dept_level"
          :clearable="false"
          filterable
          searchable
          :error="errors.dept_level"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputGroup from '@/components/InputGroup.vue';
import SelectGroup from '@/components/SelectGroup.vue';
import { apiPost, generateFormData } from '@/modules/apiHelper';
import form from '@/modules/formHelper';

export default {
  name: 'KengenUserSignUp',
  components: {
    InputGroup,
    SelectGroup,
  },
  props: {
    title: {
      type: String,
      default: 'KenGen details',
    },
    // defaultValues: {
    //   type: Object,
    //   default: {},
    // }
  },
  data() {
    return {
      pageIsLoading: true,
      form: {
        staff: undefined,
        regional: undefined,
        section: undefined,
        dept_level: undefined, // grade
      },
      errors: {
        staff: undefined,
        regional: undefined,
        section: undefined,
        dept_level: undefined,
      },
      regionalList: [],
      sectionList: [],
      deptLevelList: [],
    };
  },
  watch: {
    form: {
      async handler(data) {
        await this.$nextTick();
        this.$emit('input', {
          ...data,
          department: this.departmentId,
          division: this.divisionId,
        });
      },
      deep: true,
    },
    'form.staff': function (val) {
      if (!form.isValidSelectInput(val)) {
        this.errors.staff = 'Staff is required';
      } else {
        this.errors.staff = undefined;
      }
    },
    'form.regional': function (val) {
      if (!form.isValidSelectInput(val)) {
        this.errors.regional = 'Regional is required';
      } else {
        this.errors.regional = undefined;
      }
    },
    'form.section': function (val) {
      if (!form.isValidSelectInput(val)) {
        this.errors.section = 'Section is required';
      } else {
        this.errors.section = undefined;
      }
    },
    'form.dept_level': function (val) {
      if (!form.isValidSelectInput(val)) {
        this.errors.dept_level = 'Department level is required';
      } else {
        this.errors.dept_level = undefined;
      }
    },
  },
  computed: {
    departmentId() {
      if (!this.form.section) return undefined;

      return this.sectionList.find((section) => Number(section.id) === Number(this.form.section))?.departid;
    },
    divisionId() {
      if (!this.form.section) return undefined;

      return this.sectionList.find((section) => Number(section.id) === Number(this.form.section))?.divid;
    },
  },
  async mounted() {
    this.pageIsLoading = true;

    await this.$store.dispatch('evaluateScope');
    await this.$store.dispatch('setScope');
    await this.$nextTick();

    const { scopeId } = this.$store.getters;

    const requests = [
      // {
      //   action: 'staff_no',
      //   endpoint: 34,
      //   dataName: 'staffList',
      // },
      {
        action: 'regions',
        endpoint: 34,
        dataName: 'regionalList',
      },
      {
        action: 'sections',
        endpoint: 34,
        dataName: 'sectionList',
        nameKey: (sec) => `${sec.sections} - ${sec.division_name} division`,
      },
      // {
      //   action: 'divisions',
      //   endpoint: 34,
      //   dataName: 'divisionList',
      // },
      // {
      //   action: 'departments',
      //   endpoint: 34,
      //   dataName: 'departmentList',
      // },
      // {
      //   action: 'sub_area',
      //   endpoint: 34,
      //   dataName: 'subAreaList',
      // },
      {
        action: 'dept_level',
        endpoint: 34,
        dataName: 'deptLevelList',
      },
      // {
      //   action: 'profession',
      //   endpoint: 0,
      //   dataName: 'designationList',
      // },
    ];
    let requestsErrorCount = 0;

    const requestsPromises = requests.map((req) => apiPost(
      req.action,
      generateFormData({ companyid: scopeId }),
      req.endpoint,
    ));

    await Promise.all(requestsPromises)
      .catch((err) => {
        console.warn(err);
        this.$toasted.global.appError({ duration: 10000 });
        this.pageIsLoading = true;
      })
      .then((res) => {
        if (!res) return;
        res.forEach(({ data, error }, i) => {
          if (error) {
            console.error('error in fetching... ', res[i]);
            requestsErrorCount += 1;
            return;
          }
          if (!data[requests[i].action]) {
            console.error('data not found for \'', `${requests[i]}'`);
            requestsErrorCount += 1;
            return;
          }

          if (requests[i].nameKey) {
            data[requests[i].action].forEach((item) => {
              item.name = requests[i].nameKey(item);
            });
          }

          this[requests[i].dataName] = data[requests[i].action];
        });

        if (requestsErrorCount === 0) {
          this.pageIsLoading = false;

          // this.form = Object.assign({}, this.form, this.defaultValues)
        }
      });
  },
};
</script>

<style>

</style>
